import * as React from 'react'

const MicrosoftExcel = React.forwardRef<
  SVGSVGElement,
  React.SVGProps<SVGSVGElement> & { color?: string }
>(({ color = '#fff', ...props }, ref) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    fill="none"
    viewBox="0 0 20 20"
    {...props}
    ref={ref}
  >
    <path
      fill={color}
      d="M15.625 1.875h-10a1.25 1.25 0 0 0-1.25 1.25V5h-1.25a1.25 1.25 0 0 0-1.25 1.25v7.5A1.25 1.25 0 0 0 3.125 15h1.25v1.875a1.25 1.25 0 0 0 1.25 1.25h10a1.25 1.25 0 0 0 1.25-1.25V3.125a1.25 1.25 0 0 0-1.25-1.25M12.5 8.125h3.125v3.75H12.5zm3.125-1.25H12.5V6.25A1.25 1.25 0 0 0 11.25 5V3.125h4.375zm-10-3.75H10V5H5.625zm-2.5 3.125h8.125v7.5H3.125zm2.5 8.75H10v1.875H5.625zm5.625 1.875V15a1.25 1.25 0 0 0 1.25-1.25v-.625h3.125v3.75zm-6.105-5.4L6.375 10l-1.23-1.475a.625.625 0 1 1 .96-.8l1.082 1.298L8.27 7.725a.625.625 0 1 1 .96.8L8 10l1.23 1.475a.625.625 0 1 1-.96.8l-1.082-1.298-1.083 1.298a.625.625 0 0 1-.96-.8"
    ></path>
  </svg>
))

MicrosoftExcel.displayName = 'MicrosoftExcel'

export { MicrosoftExcel }
